import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationFill = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36 20c0 8.838-7.164 16-16 16S4 28.838 4 20c0-8.833 7.164-16 16-16s16 7.167 16 16Zm-16 3.226a2.968 2.968 0 1 0 0 5.935 2.968 2.968 0 0 0 0-5.935Zm-2.818-10.668.479 8.774c.022.411.362.732.773.732h3.132c.411 0 .75-.32.773-.732l.479-8.774a.774.774 0 0 0-.773-.816h-4.09a.774.774 0 0 0-.773.816Z" })
});
export default SvgExclamationFill;
